import React from "react";
import { useSupportHeaderSlide } from "@/v2-components/pages/support/hooks/use-support-header-slide";
import { SupportAccordionSlide } from "@/v2-components/pages/support/components/shared/support-accordion-slide";
import { SupportHeaderSlideFixContents } from "@/v2-components/pages/support/shared/support-header-slide-fix-contents";
import { HelpCenterSlideTree } from "@/v2-components/pages/support/components/shared/help-center-slide-tree";
import { HelpContextProvider } from "@/v2-components/pages/support/context/help-center.context";
import type { SupportCategory } from "@/v2-components/pages/support/types/support-data";

export const SupportFaqSlideSection = ({ faqs }: { faqs: SupportCategory }) => {
  const { isSlideOpen, slideStandardRef, handleSlideToggle, handleSlideClose } =
    useSupportHeaderSlide();

  return (
    <SupportAccordionSlide
      isOpen={isSlideOpen}
      setIsOpen={handleSlideToggle}
      fixedContent={
        <SupportHeaderSlideFixContents
          slideStandardRef={slideStandardRef}
          slideOpen={isSlideOpen}
          setSlideOpen={handleSlideToggle}
          title={"FAQ"}
        />
      }
      slideContent={
        <HelpContextProvider>
          <HelpCenterSlideTree
            data={faqs.children || []}
            onCloseSlide={handleSlideClose}
            query={"categories"}
          />
        </HelpContextProvider>
      }
    />
  );
};
